export enum LogoSizeEnum {
	X_SMALL = 'x-small',
	SMALL = 'small',
	NORMAL = 'normal'
}

export const LOGO_SIZE_ENUM_VALUES = Object.values(LogoSizeEnum);
